import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import {
  Box, 
  Button, 
  Grid, 
  Paper, 

  TextField, 
  Toolbar, 
  Typography
} from '@mui/material';


import {
  useFetchTournamentsQuery, 
  useUpdateTournamentMutation,
} from '../../store/tournament/TournamentApi';


/*
 * Geld-Felder für das Turnier - legt fest, welche
 * Felder hier dargestellt werden können...
 */
const FeeField = ({label, name, value, onChange}) => 
(
  <TextField
    label={label} name={name} value={value} onChange={onChange}
    type="number" size="small" inputProps={{step:'0.50'}}
    sx={{ width: '160px' }}
  />
);

/*
 * Darstellen der unterschiedlichen Bearbeitungsmöglichkeiten für das Turnier...
 */
export default function ParametersAdmin()
{
  // Als Parameter wird das aktuelle Jahr mit übergeben (als Teil des Routings)
  const {year} = useParams();
  const currentYear = parseInt(year);

  // schnappen wir uns als erstes alle vorhandenen Turniere
  const { data : tournaments } = useFetchTournamentsQuery();
  const [updateTournament] = useUpdateTournamentMutation();

  // Prüfen, ob es das Turnier aus dem aktuellen Jahr gibt. 
  const existsTournament = tournaments?.find( t => t.year === currentYear );

  // Zurücksetzen auf eine leere Seite
  const emptyTournament = 
  {
    name:                 '', 
    counter:              '', 
    dateFrom:             '', 
    dateUpto:             '',
    fee_saturday:         '', 
    fee_weekend:          '', 
    fee_overnight:        '',
    fee_breakfast:        '', 
    fee_lunch:            '',
    fee_saturday_local:   '', 
    fee_weekend_local:    '', 
    fee_overnight_local:  '',
    fee_breakfast_local:  '', 
    fee_lunch_local:      '',
    fee_bar_set:          '', 
    fee_bar_set_local:    '',
    max_wu8:              0, 
    max_wu10:             0, 
    max_mu8:              0, 
    max_mu10:             0, 
    bar_sets_ordered:     0,
    bar_sets_own:         0,
  };

  // Hier behalten wir die Daten des Turniers und 
  // reagieren darauf, wenn sich hier etwas ändert
  const [form, setForm] = useState(emptyTournament);

  // Stellt sicher, dass wir auch wirklich das aktuelle Turnier, 
  // welches derzeit bearbeitet wird, auch wirklich kennen...
  useEffect(() => {
    if (existsTournament) setForm(existsTournament);
  }, [existsTournament]);

  
  // Änderung eines Wertes berücksichtigen - hier reagieren wird
  // darauf, dass sich eine Änderung ergibt und kopieren alle Werte, 
  // bis auf den gerade geänderten
  const handleChange = (e) => 
  {
    setForm(prev => 
      (
        { ...prev, [e.target.name]: e.target.value }
      )
    );
  };


  // Aktualisierung des betroffenen Turniers - hier müssen wir allerdings
  // jenes Jahr auswählen, welches jetzt als das aktuelle gilt..
  const handleSave = async () => 
  {
    try {
      await updateTournament({ year: currentYear, ...form }).unwrap();
    } catch (err) {
      console.error(err);
    }
  };



  return (
    <Box sx={{ p: 2 }}>
      <Toolbar>
        <Typography variant="h5" sx={{ flexGrow: 1 }}>
          Turnierverwaltung {currentYear}
        </Typography>

        <Button variant="contained" onClick={handleSave} sx={{ ml: 2 }}>
          Speichern
        </Button>    
      </Toolbar>

      <Paper sx={{ p: 2, mt: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}><Typography variant="h6">Basisdaten</Typography></Grid>
          <Grid item><TextField label="Name" name="name" value={form.name} onChange={handleChange} size="small" sx={{ width: 280 }} /></Grid>
          <Grid item><TextField label="Nr." name="counter" value={form.counter} onChange={handleChange} type="number" size="small" sx={{ width: 80 }} /></Grid>
          <Grid item><TextField label="Von" name="dateFrom" value={form.dateFrom} onChange={handleChange} type="date" size="small" InputLabelProps={{ shrink: true }} /></Grid>
          <Grid item><TextField label="Bis" name="dateUpto" value={form.dateUpto} onChange={handleChange} type="date" size="small" InputLabelProps={{ shrink: true }} /></Grid>
        </Grid>
      </Paper>

      {[
        { title: 'Beiträge Gäste',      fields: [['Samstag','fee_saturday'],['Wochenende','fee_weekend'],['Übernachtung','fee_overnight']] },
        { title: 'Beiträge Heimverein', fields: [['Samstag','fee_saturday_local'],['Wochenende','fee_weekend_local'],['Übernachtung','fee_overnight_local']] },
        { title: 'Verpflegung Gäste',   fields: [['Frühstück','fee_breakfast'],['Abendessen','fee_lunch']] },
        { title: 'Verpflegung Heimverein', fields: [['Frühstück','fee_breakfast_local'],['Abendessen','fee_lunch_local']] },
        { title: 'Bierbänke',           fields: [['Preis Gäste','fee_bar_set'],['Preis Heimverein','fee_bar_set_local']] },
      ].map(({ title, fields }) => (
        <Paper key={title} sx={{ p: 2, mt: 1 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>{title}</Typography>
          <Grid container spacing={2}>
            {fields.map(([label, name]) => (
              <Grid item key={name}>
                <FeeField label={label} name={name} value={form[name]} onChange={handleChange} />
              </Grid>
            ))}
          </Grid>
        </Paper>

      ))}

      <Paper sx={{ p: 2, mt: 1 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Bestellung von Bierbänken</Typography>
        <Grid container spacing={2}>
          <Grid item>
            <TextField label="Gesamt bestellt" name="bar_sets_ordered"
              value={form.bar_sets_ordered ?? 0} onChange={handleChange}
              type="number" size="small" inputProps={{ min: 0, step: 1 }} sx={{ width: '160px' }} />
          </Grid>
          <Grid item>
            <TextField label="Eigenbedarf Turnier" name="bar_sets_own"
              value={form.bar_sets_own ?? 0} onChange={handleChange}
              type="number" size="small" inputProps={{ min: 0, step: 1 }} sx={{ width: '160px' }} />
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ p: 2, mt: 1 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>Kapazitäten</Typography>
      <Grid container spacing={2} alignItems="center">
        {
          [
            ['wU8', 'max_wu8'], 
            ['wU10', 'max_wu10'], 
            ['mU8', 'max_mu8'], 
            ['mU10', 'max_mu10']
        ].map(([label, name]) => (
          <Grid item key={name}>
            <TextField
              label={label} name={name} value={form[name] ?? 1}
              onChange={handleChange}
              type="number" size="small"
              inputProps={{ min: 1, step: 1 }}
              sx={{ width: '100px' }}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>

    </Box>
  );
}
 